import filooImg from '@/assets/images/pages/aas/filoo.jpg'
import dasaImg from '@/assets/images/pages/aas/dasa.jpg'

export default [
  {
    theme: "default",
    background: "#F5F5F5",
    font: "bold 40px Arial",
    color: "#333333",
    textAlign: "right"
  },
  {
    theme: "filoo",
    background: "#F29200",
    font: "bold 40px Arial",
    color: "#FFFFFF",
    textAlign: "right"
  },
  {
    theme: "dasa",
    background: "#38B6FF",
    font: "bold 40px Arial",
    color: "#FFFFFF",
    textAlign: "right"
  }
]

export const layouts = {
  filoo: filooImg,
  dasa: dasaImg
}
